import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Portfolio from "../components/Portfolio";
import WhyUs from "../components/WhyUs";
import Consultancy from "../components/Consultancy";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  const [stats, setStats] = useState(null);
  const location = useLocation();

  // Cross-route hash scroll: when navigating to /#services from another route,
  // React Router doesn't scroll natively. Scroll to the target section on mount / hash change.
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    if (id === "home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    // Wait for sections to mount, then scroll
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 300);
    return () => clearTimeout(t);
  }, [location.pathname, location.hash]);

  return (
    <div className="App" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <About stats={stats} />
        <Services />
        <Portfolio onStatsReady={setStats} />
        <WhyUs />
        <Contact />
        <Consultancy />
      </main>
      <Footer />
    </div>
  );
}
